import { Component, OnInit, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { MenuItem, SelectItem, ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Menu } from 'primeng/menu';
import { TranslateService } from '@ngx-translate/core';
import { Contract, ContractErrorData } from 'src/app/intefaces/contract.interface';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { ContractService } from 'src/app/services/contract.service';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { ContractSearchParams } from 'src/app/intefaces/contract-search-params.interface';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-contracts',
    templateUrl: './contracts.component.html',
    animations: [
        trigger('rowExpansionTrigger', [
            state('void', style({
                transform: 'translateX(-10%)',
                opacity: 0
            })),
            state('active', style({
                transform: 'translateX(0)',
                opacity: 1
            })),
            transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    styleUrls: ['./contracts.component.scss'],
    providers: [ConfirmationService]
})
export class ContractsComponent implements OnInit {

    @ViewChild('tt') table: Table;
    @ViewChild('menu') menu: Menu;

    @Input() userId?: number;

    contracts: Contract[] = [];
    showLoader: boolean = true;
    rowsOnPage: number = 50;
    page: number = 0;
    first: number = 0;
    totalRecords: number = 0;
    showFilters: boolean = false;
    contractStatus: SelectItem[];
    role: string = 'customer';
    contractSearchParams: ContractSearchParams = { status: 'all' };

    styleClassName: string = 'arranger-contracts'
    functionsMenu: MenuItem[] = [];
    calendar_pl: any;
    selectedContractId: number = null;
    showForm: boolean = false;
    _showAttachments: boolean = false;

    constructor(
        private translate: TranslateService,
        private cdRef: ChangeDetectorRef,
        private confirmationService: ConfirmationService,
        private alertService: HttpAlertService,
        private contractService: ContractService,
        private storage: BrowserStorageService
    ) { }


    ngOnInit() {
        this.initStatus();
        this.calendar_pl = {
            firstDayOfWeek: 1,
            dayNames: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piąte", "Sobota"],
            dayNamesShort: ["Niedz", "Pon", "Wto", "Śr", "Czw", "Pt", "Sob"],
            dayNamesMin: ["Nd", "Po", "Wt", "Śr", "Czw", "Pt", "So"],
            monthNames: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
            monthNamesShort: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Czer", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
            today: 'Dziś',
            clear: 'Wyczyść',
            dateFormat: 'dd/mm/yy',
            weekHeader: 'Tyd'
        };
        this.role = this.storage.get('_role');
        this.styleClassName = 'admin' == this.role ? 'admin-panel' : this.styleClassName;
        this.styleClassName = this.userId ? 'admin-arranger-details' : this.styleClassName;
    }

    public onLoadContractLazy(event: any): void {
        this.showLoader = true;
        this.page = event.first / event.rows;
        this.rowsOnPage = event.rows;
        this.loadContracts();
    }

    public loadContracts(): void {
        if (this.contractSearchParams.date_month != null) {
            let month: number = this.contractSearchParams.date_month.getMonth() + 1;
            this.contractSearchParams.month_obj = {
                m: month < 10 ? '0' + String(month) : month,
                y: this.contractSearchParams.date_month.getFullYear()
            }
        }

        this.contractService.getContractSearch(this.contractSearchParams, this.page, this.rowsOnPage, this.userId).subscribe((response: any) => {
            let _tempData = response.data.contracts;
            _tempData.forEach((e: Contract, index) => {
                e.error_data_obj = this.prepareErrorData(e.error_data);
                if(e.status == 'accepted' && this.role == 'admin') {
                    this.getAttachments(index, e.id);
                }
                
            });
            this.contracts = _tempData;
            if (this.page == 0) {
                this.totalRecords = response.data.total;
            }
            this.showLoader = false;
        });
    }

    private prepareErrorData(error_data: string): ContractErrorData {
        let data: ContractErrorData = JSON.parse(error_data);
        return data;
    }

    public onToggleFilters(): void {
        if ('admin' == this.role) {
            this.showFilters = this.showFilters ? false : true;
        }
    }

    public onSearchContracts(): void {
        this.showLoader = true;
        this.page = 0;
        this.first = 0;
        this.loadContracts();
    }

    public onPopulateFunctionsMenu(event: any, id: number): void {
        this.translate.get(['contract_download', 'contract_edit', 'contract_accept', 'contract_show_attachemnts', 'contract_generate_new']).subscribe(t => {
            this.functionsMenu = [];
            let contract = this.getContract(id);
            let s: string = contract.status;

            if ('new' == s || 'accepted' == s || 'signed' == s) {
                this.functionsMenu.push({ label: t.contract_download, command: (click) => { this.downloadContract(id) } });
            }

            if (('new' == s || 'accepted' == s || 'error' == s) && 'admin' == this.role) {
                this.functionsMenu.push({ label: t.contract_edit, command: (click) => { this.editContract(id) } });
            }

            if (('new' == s) && 'admin' == this.role) {
                this.functionsMenu.push({ label: t.contract_accept, command: (click) => { this.acceptContract(id) } });
            }

            if ('accepted' == s || 'signed' == s) {
                this.functionsMenu.push({ label: t.contract_show_attachemnts, command: (click) => { this.showAttachments(id) } });
            }

            if (('new' == s || 'accepted' == s || 'error' == s) && 'admin' == this.role) {
                this.functionsMenu.push({ label: t.contract_generate_new, command: (click) => { this.generateNewContract(id) } });
            }
            this.menu.toggle(event);
        });
    }

    private generateNewContract(id: number): void {
        if ('admin' == this.role) {
            this.getConfrimation('contract_set_to_default').then((confirmation: boolean) => {
                if (confirmation) {
                    this.contractService.setContractToDefault(id).subscribe((response: any) => {
                        if ('OK' == response.data.status) {
                            this.alertService.success('contract_set_to_default_confriamtion');
                            this.replaceContract(response.data.contract);
                        } else if ('CANNOT_GENERATE_NEW_CONTRACT' == response.data.status) {
                            this.alertService.error('contract_error_cannot_generate');
                        } else if ('CONTRACT_NOT_FOUND' == response.data.status) {
                            this.alertService.error('contract_error_incorrect_contract_id');
                        } else {
                            this.alertService.error('contract_error_general');
                        }
                    });
                }
            });
        }
    }

    private acceptContract(id: number): void {
        if ('admin' == this.role) {
            this.getConfrimation('contract_acceptation').then((confirmation: boolean) => {
                if (confirmation) {
                    this.contractService.acceptContract(id).subscribe((rersponse: any) => {
                        let status: string = rersponse.data.status;
                        if ('STATUS_CHANGED' == status) {
                            this.alertService.success('contract_accepted');
                            for (let i = 0; i < this.contracts.length; i++) {
                                if (this.contracts[i].id == id) {
                                    this.contracts[i].status = 'accepted';
                                }
                            }
                        } else if ('CANNOT_CHANGE_STATUS' == status) {
                            this.alertService.error('contract_erro_connot_change_status');
                        } else if ('CONTRACT_NOT_FOUND' == status) {
                            this.alertService.error('contract_error_incorrect_contract_id');
                        } else {
                            this.alertService.error('contract_error_general');
                        }
                    });
                }
            });
        }
    }

    public showAttachments(id: number): void {
        this._showAttachments = true;
        this.selectedContractId = id;
    }

    public onCloseAttachmentsModal(id: number) {
        this._showAttachments = false;
        this.selectedContractId = null;
        this.contractService.getContract(id).subscribe((response: any) => {
            if (null != response.data.contract) {
                this.replaceContract(response.data.contract);
            }
        });
    }

 
    getAttachments(idx, id) {
        this.contractService.getContractAttachments(id).subscribe((response: any) => {
            this.contracts[idx].attachments = response.data.contrract_attachments;
        });
    }

    public downloadContract(id: number): void {
        this.contractService.downloadContract(id).subscribe((response: any) => {
            if (response.size > 10) {
                for (let i = 0; i < this.contracts.length; i++) {
                    if (this.contracts[i].id == id) {
                        let filename: string = this.contracts[i].contract_no.replace(/\//g, '_');
                        saveAs(response, filename + '.pdf');
                    }
                }
            } else {
                this.alertService.error('contract_error_general');
            }
        }, error => console.error(error));
    }

    public onRefreshSearch(): void {
        this.contractSearchParams = { status: 'all' };
        this.showFilters = false
        this.onSearchContracts();
    }

    private initStatus(): void {
        this.translate.get(['contract_status_new', 'contract_status_error', 'contract_status_accepted', 'contract_status_signed', 'contract_status_all']).subscribe(t => {
            setTimeout(() => {
                this.contractStatus = [
                    { label: t.contract_status_all, value: 'all' },
                    { label: t.contract_status_new, value: 'new' },
                    { label: t.contract_status_error, value: 'error' },
                    { label: t.contract_status_accepted, value: 'accepted' },
                    { label: t.contract_status_signed, value: 'signed' },
                ];
            });
        })
    }

    public getContract(id: number): Contract {
        for (let i = 0; i < this.contracts.length; i++) {
            if (this.contracts[i].id == id) {
                return this.contracts[i];
            }
        }
        return null;
    }

    private editContract(id: number): void {
        if ('admin' == this.role) {
            this.selectedContractId = id;
            this.showForm = true;
        }
    }

    private replaceContract(c: Contract): void {
        if (null != c) {
            for (let i = 0; i < this.contracts.length; i++) {
                if (this.contracts[i].id == c.id) {
                    this.contracts[i].name = c.name;
                    this.contracts[i].surname = c.surname;
                    this.contracts[i].contract_date = c.contract_date;
                    this.contracts[i].contract_no = c.contract_no;
                    this.contracts[i].error_data = c.error_data;
                    this.contracts[i].error_data_obj = this.prepareErrorData(c.error_data);
                    this.contracts[i].status = c.status;
                }
            }
        }
    }

    public onFinishEditing(id: number): void {
        if ('admin' == this.role) {
            if (id) {
                this.contractService.getContract(id).subscribe((response: any) => {
                    if (null != response.data.contract) {
                        this.replaceContract(response.data.contract);
                    }
                    this.selectedContractId = null;
                    this.showForm = false;
                    this.cdRef.detectChanges();
                });
            } else {
                this.selectedContractId = null;
                this.showForm = false;
            }
        }
    }

    public getConfrimation(title: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.confirmationService.confirm({
                message: this.translate.instant(title),
                accept: () => { resolve(true); },
                reject: () => { resolve(false); }
            });
        });
    }

}
